import React from "react";
import ExamsHome from "./ExamsHome";

function App() {
  return (
    <div style={{ fontFamily: "Cairo" }}>
      <ExamsHome />
    </div>
  );
}

export default App;
